import commonActionTypes from './action-types';

export const setContext = payload => ({
  type: commonActionTypes.SET_CONTEXT,
  payload,
});

export const fetchConfigurations = value => ({
  type: commonActionTypes.FETCH_CONFIGURATIONS,
  payload: value,
});

export const fetchConfigurationsSuccess = value => ({
  type: commonActionTypes.FETCH_CONFIGURATIONS_SUCCESS,
  payload: value,
});

export const fetchConfigurationsFail = value => ({
  type: commonActionTypes.FETCH_CONFIGURATIONS_FAIL,
  payload: value,
});
